export default __webpack_public_path__ + "static/media/Privacy.eba72534.webp";